// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:1000px){*[data-v-27944d4c] .v-skeleton-loader__avatar{height:70px;width:70px;margin:auto}}@media only screen and (min-width:1000px){*[data-v-27944d4c] .v-skeleton-loader__avatar{height:110px;width:110px;margin:auto}}", ""]);
// Exports
module.exports = exports;
